import React, { useCallback, useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { API_URLS } from "../../config/apiUrls";
import CategoriasCardCategoria from "../CategoriasCardCategoria";

interface Subcategoria {
  id: string;
  name: string;
  isDeleted: boolean;
}

interface Categoria {
  id: string;
  name: string;
  segment: string;
  subcategories: Subcategoria[];
}

interface CategoriasProps {
  token: string;
  shouldUpdateList: boolean;
  updateAddCategories: () => void;
}

const ordem = ["MARKET", "PETS", "HANDICRAFTS", "SERVICES"];

const CategoriasLista: React.FC<CategoriasProps> = ({
  token,
  shouldUpdateList,
  updateAddCategories,
}) => {
  const [categorias, setCategorias] = useState<Categoria[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCategorias = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URLS.categorias}/with-deleted`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error("Não foi possível carregar as categorias.");
      const data = (await response.json()) as Categoria[];
      setCategorias(
        data
          .map((categoria) => ({
            ...categoria,
            subcategories: [...(categoria.subcategories || [])].sort((a, b) =>
              a.name.localeCompare(b.name)
            ),
          }))
          .sort((a, b) => ordem.indexOf(a.segment) - ordem.indexOf(b.segment))
      );
    } catch (error) {
      console.error("Erro ao buscar categorias:", error);
    } finally {
      setIsLoading(false);
    }
  }, [token]);

  useEffect(() => {
    void fetchCategorias();
  }, [fetchCategorias, shouldUpdateList]);

  const handleSubcategoriaUpdated = () => {
    void fetchCategorias();
    updateAddCategories();
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Typography marginTop={3} variant="h5" textAlign="center">
        <strong>Categorias fixas e subcategorias</strong>
      </Typography>
      <Box
        marginTop={2}
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: 2,
          width: "100%",
        }}
      >
        {isLoading ? (
          <CircularProgress size={24} />
        ) : (
          categorias.map((categoria) => (
            <CategoriasCardCategoria
              key={categoria.id}
              token={token}
              categoria={categoria}
              isLoading={isLoading}
              onSubcategoriaUpdated={handleSubcategoriaUpdated}
            />
          ))
        )}
      </Box>
    </Box>
  );
};

export default CategoriasLista;
